// SourceSummary — a source's overview, pure projection of `LoadedSource.summary`
// (FR-13.1). The summary is agent-written, so it carries the AiMarker (FR-2.7)
// and renders as markdown like the agent's other text. No summary yet renders
// nothing (no half-baked placeholder).

import { useLingui } from "@lingui/react/macro";
import type { ReactNode } from "react";
import { AiMarker } from "../AiMarker/AiMarker.js";
import { Prose } from "../Prose/Prose.js";
import { Text } from "../Text/Text.js";

export type SourceSummaryProps = {
    readonly summary: string | undefined;
};

export const SourceSummary = ({ summary }: SourceSummaryProps): ReactNode => {
    const { t } = useLingui();
    if (summary === undefined || summary.trim().length === 0) return null;
    return (
        <section className="bilda-source-summary" aria-label={t`Summary`}>
            <Text as="p" size="sm" weight="semibold">
                {t`Summary`} <AiMarker />
            </Text>
            <Prose>{summary}</Prose>
        </section>
    );
};
